import { NavLink } from 'react-router-dom';

import { cn } from '../../lib/cn';
import { CLIENT_TABS } from '../Sidebar/navItems';
import styles from './ClientSubNav.module.css';

/**
 * The tabs under the single "ניהול לקוח" sidebar entry. Shown at the top of
 * every page that entry owns, so moving between customers, quotes, projects,
 * tasks, hours and money never needs the sidebar.
 */
export function ClientSubNav() {
  return (
    <nav className={styles.subnav} aria-label="ניהול לקוח">
      {CLIENT_TABS.map((t) => (
        <NavLink
          key={t.path}
          to={t.path}
          className={({ isActive }) => cn(styles.tab, isActive && styles.tabActive)}
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
